// @flow

import type {Article} from 'docs/data';

const ARTICLE_LOADED = 'ARTICLE_LOADED';
const ARTICLE_LOADING = 'ARTICLE_LOADING';

export type ArticleLoadingEvent = {|
  type: typeof ARTICLE_LOADING,
  payload: {},
|};

export const articleLoading = (): ArticleLoadingEvent => ({
  type: ARTICLE_LOADING,
  payload: {},
});

export type ArticleLoadedEvent = {|
  type: typeof ARTICLE_LOADED,
  payload: {article: Article},
|};

export const articleLoaded = (article: Article) => ({
  type: ARTICLE_LOADED,
  payload: {article},
});

export type ArticleEvent = ArticleLoadingEvent | ArticleLoadedEvent;

export type ArticleReducerState = {|
  article: Article,
  isLoading: boolean,
|};

export const ArticleReducer = (
  state: ArticleReducerState,
  event: ArticleEvent,
) => {
  switch (event.type) {
    case ARTICLE_LOADING:
      return {
        ...state,
        isLoading: true,
      };
    case ARTICLE_LOADED:
      return {
        ...state,
        article: event.payload.article,
        isLoading: false,
      };
    default:
      throw new Error(`Unknown article event ${event.type}`);
  }
};
